import { render } from "./OrdersVe.vue?vue&type=template&id=2d2e6aa8&scoped=true"
import script from "./OrdersVe.vue?vue&type=script&lang=js"
export * from "./OrdersVe.vue?vue&type=script&lang=js"

import "./OrdersVe.vue?vue&type=style&index=0&id=2d2e6aa8&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2e6aa8"]])

export default __exports__